import { render, staticRenderFns } from "./OnboardingStepper.vue?vue&type=template&id=13357c6f&"
import script from "./OnboardingStepper.vue?vue&type=script&lang=ts&"
export * from "./OnboardingStepper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports